export default "__VITE_ASSET__yTyGHST1__"